import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useSearchParams } from "react-router-dom";
import { useLicense } from "../_helper/license/LicenseContext";
import { usePharmacy } from "../_helper/PharmacyProvider";

const PrivateRoute = () => {
  const { pharmacyPOS } = usePharmacy();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const { licenseStatus, isChecking } = useLicense();
  const [initialCheckComplete, setInitialCheckComplete] = useState(false);

  // Track when initial validation completes
  useEffect(() => {
    if (!isChecking && !initialCheckComplete) {
      setInitialCheckComplete(true);
    }
  }, [isChecking, initialCheckComplete]);

  const isAuthenticated = pharmacyPOS || localStorage.getItem("currentPharmacyPOS");

  if (!isAuthenticated) {
    if (token) {
      return (
        <div style={{
          padding: 50,
          textAlign: "center",
          display: 'flex',
          alignItems: 'end',
          justifyContent: 'center',
          minHeight: '100vh'
        }}>
          <div>
            {/* <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div> */}
            <p style={{ marginTop: '20px' }}>Authenticating...</p>
          </div>
        </div>
      );
    }
    return <Navigate to={`${process.env.PUBLIC_URL}/login`} replace />;
  }

  // Show loading screen during initial validation
  if (!initialCheckComplete) {
    return (
      <div style={{
        padding: 50,
        textAlign: "center",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh'
      }}>
        <div>
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <p style={{ marginTop: '20px' }}>Validating license...</p>
        </div>
      </div>
    );
  }

  // Once validation is complete, check status
  if (licenseStatus === 'valid') {
    return <Outlet />;
  }

  // IMMEDIATELY redirect for any invalid status
  if (licenseStatus === 'time-tampered') {
    return <Navigate to={`${process.env.PUBLIC_URL}/activate?error=time-tamper`} replace />;
  }

  if (licenseStatus === 'expired') {
    return <Navigate to={`${process.env.PUBLIC_URL}/activate?error=expired`} replace />;
  }

  // console.log(licenseStatus);

  // For all other statuses (invalid, none, etc)
  return <Navigate to={`${process.env.PUBLIC_URL}/activate`} replace />;
};

export default PrivateRoute;
// import React from "react";
// import { Navigate, Outlet } from "react-router-dom";

// const PrivateRoute = ({ isLoggedIn }) => {
//   return isLoggedIn ? <Outlet /> : <Navigate to={`${process.env.PUBLIC_URL}/login`} />;
// };

// export default PrivateRoute;


// import { Navigate, Outlet } from "react-router-dom";
// import { useLicense } from "../license/LicenseProvider";

// const PrivateRoute = () => {
//   const { status } = useLicense();

//   if (status === "checking") return <div>Loading license...</div>;

//   if (status === "no-license")
//     return <Navigate to="/activate" replace />;

//   if (status === "invalid")
//     return <Navigate to="/activate?error=invalid" replace />;

//   if (status === "expired")
//     return <Navigate to="/activate?error=expired" replace />;

//   if (status === "time-tampered")
//     return <Navigate to="/activate?error=time-tamper" replace />;

//   return <Outlet />;
// };

// export default PrivateRoute;
